import { Collapse, Offcanvas } from 'bootstrap';
import hoverintent from 'hoverintent';

function handleBlockGridHero(): void {
  const blockGridHeroPageComponentElement = document.querySelector('.block-grid-hero .page-component') as HTMLElement;
  const headerElement = document.querySelector('#header') as HTMLElement;

  if (blockGridHeroPageComponentElement && headerElement) {
    headerElement.classList.add('header-with-block-grid-hero');

    let applyBlockGridPadding = function() {
      let headerHeight = headerElement.getBoundingClientRect().height;
      blockGridHeroPageComponentElement.style.paddingTop = `${headerHeight}px`;
    }
    applyBlockGridPadding();
    window.addEventListener('resize', applyBlockGridPadding);
  }
}

function handleOffcanvasEvents(): void {
  const offcanvasOffsetElement = document.querySelector<HTMLElement>('header');
  const offcanvasButton = document.getElementById('headerOffcanvasButton');
  const offcanvas = document.getElementById('headerOffcanvas');

  if (offcanvasOffsetElement && offcanvasButton && offcanvas) {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
      offcanvasButton.classList.add('offcanvas-open');
      const topOffset = offcanvasOffsetElement.getBoundingClientRect().bottom;
      offcanvas.style.top = `${topOffset}px`;
    });

    offcanvas.addEventListener('hide.bs.offcanvas', () => {
      offcanvasButton.classList.remove('offcanvas-open');
    });
  }
}

function handleMainNavigationEvents(): void {
  const navDropdownLinks = Array.from(document.querySelectorAll<HTMLElement>('.main-navigation-link-dropdown'));
  const navItems = Array.from(document.querySelectorAll<HTMLElement>('.main-navigation-item'));
  const navDropdownsContainer = document.querySelector('.main-navigation-items');

  if (navDropdownLinks.length && navItems.length && navDropdownsContainer) {
    navDropdownLinks.forEach(dropdownLink => {
        const navItem = dropdownLink.closest('.main-navigation-item');
        dropdownLink.addEventListener('click', (event) => {
          activateDropdown(navItem, event);
          deactivateDropdowns(navItems.filter(x => x !== navItem));
        });
        if (navItem) {
          hoverintent(
            navItem,
            (event) => {
              activateDropdown(navItem, event);
              deactivateDropdowns(navItems.filter(x => x !== navItem));
            },
            () => {
              deactivateDropdowns([navItem]);
            }
          ).options({ timeout: 200 });
        }
    });
  }
}

function deactivateDropdowns(navItems) {
  navItems.forEach(navItem => {
    navItem.classList.remove('active');
  });
}

function activateDropdown(navItem, event) {
  if (!navItem.classList.contains('active')) {
    if (event.type === 'click') {
      // If clicked and dropdown is not active, then suppress the link trigger
      event.preventDefault();
    }
    navItem.classList.add('active');
  }
}

function handleKeyboardAndMouseEvents(): void {
  // On escape keypress, collapse all header collapses
  const headerCollapses = document.querySelectorAll<HTMLElement>('header .collapse, .main-navigation-wrapper .collapse');
  if (headerCollapses.length) {
    document.addEventListener('keydown', (event) => {
      if (event?.key === 'Escape' || event?.key === 'Esc') {
        headerCollapses.forEach((headerCollapse) => {
          const collapse = Collapse.getOrCreateInstance(headerCollapse, { toggle: false });
          collapse.hide();
        });
      }
    });
  }

  // On click outside main navigation, close all main navigation collapses
  const mainNavigationWrappers = Array.from(document.querySelectorAll('.main-navigation'));
  const mainNavigationItems = Array.from(document.querySelectorAll<HTMLElement>('.main-navigation-item'));
  if (mainNavigationWrappers.length && mainNavigationItems.length) {
    document.addEventListener('click', (event) => {
      const clickedMainNavigation = mainNavigationWrappers.some(wrapper => wrapper.contains(event.target as Node));
      if (!clickedMainNavigation) {
        mainNavigationItems.forEach((mainNavigationItem) => {
          mainNavigationItem.classList.remove('active');
        });
      }
    });
  }

  // On click outside header and main navigation, close header offcanvas
  const header = document.querySelector<HTMLElement>('header');
  const headerOffcanvas = document.querySelector<HTMLElement>('#headerOffcanvas');
  if (header && headerOffcanvas) {
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target as Node) && !mainNavigationWrappers.some(wrapper => wrapper.contains(event.target as Node))) {
        const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false });
        offcanvasInstance.hide();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleBlockGridHero();
  handleOffcanvasEvents();
  handleMainNavigationEvents();
  handleKeyboardAndMouseEvents();
});
